import { render, staticRenderFns } from "./CustomLayoutContactRecord.vue?vue&type=template&id=4581eb9e&scoped=true"
import script from "./CustomLayoutContactRecord.vue?vue&type=script&lang=js"
export * from "./CustomLayoutContactRecord.vue?vue&type=script&lang=js"
import style0 from "./CustomLayoutContactRecord.vue?vue&type=style&index=0&id=4581eb9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581eb9e",
  null
  
)

export default component.exports